import { useState, useEffect } from "react";
import styles from "./AISelfJourney.module.css";
import Header from "../Header";
import InterestsPop from "../MyFeeds/Interests";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllInterestsAction,
  getUserInterestsAction,
  getUserSubInterestsAction,
} from "../../actions/profileActions";
import { Alert, Box, Snackbar } from "@mui/material";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Legend,
} from "chart.js";
import { CloseOutlined, ErrorOutline } from "@mui/icons-material";
import fetchItemsNextToken from "../../../graphql/fetchItemsNextToken";
import {
  listTblGradeMasters,
  searchCardItems,
  searchCards,
} from "../../../graphql/queries";
import fetchSearchItemsNextToken from "../../../graphql/fetchSearchItemsNextToken";
import CustomModal from "../utils/CustomModal/CustomModal";
import {
  createAIChatSession,
  generateQuestion,
  fetchAIChatBlocks,
  userAttempt,
} from "../../../services/aiChatService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { reportAI } from "../../../services/aiService";
import ChartPanel from "./ChartPanel";
import SidePanel from "./SidePanel";
import QuestionRenderer from "./QuestionRenderer";
import ChatPanel from "./ChatPanel";
import Loader from "../Loader";
import { addPDF } from "../../../services/pdfService";
import { AIChatTypes } from "../../auth/util/CustomConstants";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Legend,
  PointElement
);

const AIOwnJourney = () => {
  const { id: aiChatId } = useParams() || null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const chapterIndex = params.get("chapter");

  const profile = useSelector((state) => state.profileReducer); // profile data

  //loaders
  const [showLoader, setShowLoader] = useState(false); //main loader

  //snackbar
  const [openToast, setOpenToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [severityClass, setSeverityClass] = useState("success");

  //helper AI
  // const [userPrompt, setUserPrompt] = useState("");
  const [messages, setMessages] = useState([]);
  const [aiMode, setAIMode] = useState(true);
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [tmpMessages, setTmpMessages] = useState([]); // for switching ai mode chats
  const [chapters, setChapters] = useState([]); 
  const [selectedChapter, setSelectedChapter] = useState(null);

  //question panel
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [questionBlockId, setQuestionBlockId] = useState(null);
  const [prevUserAnswer, setPrevUserAnswer] = useState(null);
  const [isSolved, setIsSolved] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [latestQuestionIndex, setLatestQuestionIndex] = useState(0);

  //XP system
  const [remainingXP, setRemainingXP] = useState(10);
  const [attemptCount, setAttemptCount] = useState(0);

  //configure new AI chat
  const [openConfigurationModal, setOpenConfigurationModal] = useState(false);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [language, setLanguage] = useState("1");
  const [board, setBoard] = useState("1");
  const [region, setRegion] = useState("0");
  const [questionType, setQuestionType] = useState("0");
  const [questionTypes, setQuestionTypes] = useState([
    { id: 0, name: "Single Choice MCQ", slug: "single_choice_mcq" },
    // { id: 1, name: "Multiple Choice MCQ", slug: "multiple_choice_mcq" },
    // { id: 2, name: "Fill in the Blanks", slug: "fill_in_the_blanks" },
    // { id: 3, name: "True/False", slug: "true_false" },
    { id: 4, name: "Short Answer", slug: "short_answer" },
    // { id: 5, name: "Long Answer", slug: "long_answer" },
  ]);
  const [currentGrade, setCurrentGrade] = useState(
    "09fe4dbf-446c-4207-a37c-99f427b05b64"
  );
  const [gradeList, setGradeList] = useState([]);
  const [boardList, setBoardList] = useState([
    { id: 1, name: "General" },
    { id: 2, name: "CBSE" },
    { id: 3, name: "ICSE" },
    { id: 4, name: "State" },
  ]);
  const [regionList, setRegionList] = useState([
    // only for State Board and some countries
    { id: 0, name: "Global" },
    { id: 1, name: "Maharashtra" },
    { id: 2, name: "Tamil Nadu" },
    { id: 3, name: "Gujarat" },
    { id: 4, name: "Delhi" },
    { id: 5, name: "Assam" },
    { id: 6, name: "Meghalaya" },
    { id: 7, name: "United States of America" },
    { id: 8, name: "United Kingdom" },
    { id: 9, name: "Canada" },
    { id: 10, name: "Australia" },
    { id: 11, name: "Germany" },
    { id: 12, name: "France" },
    { id: 13, name: "Japan" },
    { id: 14, name: "China" },
    { id: 15, name: "Russia" },
    { id: 16, name: "Brazil" },
    { id: 17, name: "South Africa" },
  ]);
  const [languageList, setLanguageList] = useState([
    { id: 1, name: "English" },
    { id: 2, name: "Hindi" },
    { id: 3, name: "Marathi" },
    { id: 4, name: "Gujarati" },
    { id: 5, name: "Tamil" },
    { id: 6, name: "Bengali" },
    { id: 7, name: "Assamese" },
    { id: 8, name: "Oriya" },
    { id: 9, name: "Telugu" },
    { id: 10, name: "Kannada" },
    { id: 11, name: "Malayalam" },
    { id: 12, name: "Punjabi" },
    { id: 13, name: "Khasi" },
    { id: 14, name: "Garo" },
    { id: 15, name: "Chinese" },
    { id: 16, name: "Spanish" },
    { id: 17, name: "French" },
    { id: 18, name: "German" },
    { id: 19, name: "Japanese" },
  ]);

  //report modal
  const [openReportModal, setOpenReportModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState([]);
  const [reportText, setReportText] = useState("");
  const [reportFor, setReportFor] = useState("");
  const reportTagsList = [
    {
      id: 4,
      name: "Repetitive Question",
      slug: "repetitive_question",
    },
    {
      id: 2,
      name: "Incorrect Question",
      slug: "incorrect_question",
    },
    {
      id: 3,
      name: "Incorrect Options",
      slug: "incorrect_options",
    },
    {
      id: 1,
      name: "Incorrect Answer",
      slug: "incorrect_answer",
    },
  ];
  const [reportBlockId, setReportBlockId] = useState(null);
  const [aiChatDetails, setAIChatDetails] = useState(null);

  //radar chart
  const [data, setData] = useState({ labels: [], datasets: [] });

  //panel view controller
  const [sidePanel, setSidePanel] = useState(
    window.innerWidth <= 800 ? false : true
  );
  const [chartPanel, setChartPanel] = useState(false);
  const [chatPanel, setChatPanel] = useState(false); // only for mobile view
  const [showPopup, setShowPopup] = useState(false);

  const handleCloseToast = () => {
    setOpenToast(false);
  };

  const handleCloseConfigurationModal = () => {
    setOpenConfigurationModal(false);
    setSelectedPDF(null);
    setLanguage("1");
    setBoard("1");
    setRegion("0");
    setCurrentGrade("09fe4dbf-446c-4207-a37c-99f427b05b64");
  };

  const handleCloseReportModal = () => {
    setOpenReportModal(false);
  };

  const resetAll = () => {
    setLatestQuestionIndex(0);
    setAIChatDetails(null);
    setPrevUserAnswer(null);
    setMessages([]);
    setCurrentQuestion(null);
  };

  /**
   * Sets up question data for a quiz or assessment.
   *
   * @param {Object} data - The data object containing question information
   * @param {Object} data.content - The content of the question
   * @param {string} data.content.question - The text of the question
   * @param {Array} data.content.options - Available options for the question
   * @param {number} data.content.correctIndex - Index of the correct option
   * @param {number} data.questionIndex - The index or position of the question in the quiz
   *
   * @returns {void} This function doesn't return a value
   */
  const setQuestionData = (data) => {
    setAttemptCount(0);
    setRemainingXP(10);
    setIsSolved(false);
    setPrevUserAnswer(null);
    setCurrentQuestionIndex(data.questionIndex);
    setMessages([]);
    setCurrentQuestion(data);
    setQuestionBlockId(data.id);

    if (latestQuestionIndex < data.questionIndex) {
      setLatestQuestionIndex(data.questionIndex);
    }
  };

  /**
   * Fetches a new question from the AI service.
   *
   * This async function attempts to generate a new question using the current AI chat ID.
   * It handles the UI state during the fetch operation by showing a loader while in progress.
   * Upon success, it updates the question data state with the generated question.
   * If an error occurs, it displays an error toast notification to the user.
   *
   * @async
   * @function fetchQuestion
   * @returns {Promise<void>} A promise that resolves when the question fetch operation completes
   * @throws {Error} If there's an issue generating the question or if no question is found
   */
  const fetchQuestion = async () => {
    try {
      setShowLoader(true);
      if(chapterIndex === null || chapterIndex === undefined) {
        showToast("Select a Chapter", "info");
        return;
      }
      const response = await generateQuestion(aiChatId, chapterIndex);
      if (response?.status !== 200) throw Error("Error in generating question");

      const generatedQuestion = response?.data?.data?.block;
      if (!generatedQuestion) throw Error("No question found");

      setQuestionData(generatedQuestion);
    } catch (error) {
      console.error("Error in (fetchQuestion): ", error);
      showToast("Error in generating question", "error");
    } finally {
      setShowLoader(false);
    }
  };

  const updateChartData = (data) => {
    let xpData = {};
    let labels = [];
    let _data = [];
    data.forEach((item) => {
      xpData[item.topic] = {
        id: item.id,
        name: item.topic,
        level: item.level,
        xp: item.totalXP,
        xpToNextLevel: item.xpToReachNextLevel,
        questionSolved: item.questionCount,
        xpInLevel: item.xpInLevel,
      };
      labels.push(item.topic);
      _data.push(item.totalXP);
    });

    setData({
      labels: labels,
      datasets: [
        {
          label: "XP",
          data: _data,
          backgroundColor: "rgba(140, 199, 59, 0.2)",
          borderColor: "rgba(140, 199, 59, 1)",
          borderWidth: 1,
          pointBackgroundColor: "rgba(140, 199, 59, 1)",
          fill: false,
        },
      ],
    });
  };

  /**
   * Calculates progress and statistics for a user's current quiz attempt.
   *
   * @param {Array} attemptDetails - Array containing details of each attempt made by the user.
   * @param {Array} helperInteractions - Array containing details of any helper interactions used during the attempt.
   * @returns {null} Returns null if there's an error or if attemptDetails is empty.
   *
   * @description
   * This function processes attempt details and helper interactions to:
   * - Track the total number of attempts
   * - Calculate XP penalties
   * - Determine if the question was solved correctly
   * - Update UI state based on attempt results (selected option, next button visibility)
   * - Updates attempt count and remaining XP in the component state
   */
  const calculateCurrentAttemptProgress = (
    attemptDetails,
    helperInteractions
  ) => {
    try {
      if (!attemptDetails || attemptDetails.length === 0) return null;
      let totalPenalty = 0;
      let totalAttempt = 0;
      let questionSolved = false;
      let aiResponses = [];

      for (let i = 0; i < attemptDetails.length; i++) {
        const item = attemptDetails[i];
        const content = item.content;
        if (content?.isCorrect) {
          totalAttempt += 1;
          questionSolved = true;
        }

        if (!content?.isCorrect) {
          totalAttempt += 1;
          totalPenalty += content?.xpPenalty || 0;
        }
        setPrevUserAnswer(content.answer);
        if (content?.explanation?.length > 0) {
          aiResponses.push({
            role: "model",
            content: content?.explanation,
            createdAt: item.createdAt,
            isAttemptResponse: true,
            isCorrect: content?.isCorrect,
          });
        }
      }

      for (let i = 0; i < helperInteractions.length; i++) {
        const item = helperInteractions[i];
        const content = item.content;

        if (!content?.isCorrect) {
          totalPenalty += content?.xpPenalty || 0;
        }
      }

      aiResponses.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
      setMessages([...aiResponses]);

      setIsSolved(questionSolved);
      setAttemptCount(totalAttempt);
      setRemainingXP(remainingXP - totalPenalty);
    } catch (error) {
      console.error("Error in (calculateCurrentAttemptProgress): ", error);
      return null;
    }
  };

  /**
   * Handles the selection of an answer option in the AI quiz.
   *
   * @async
   * @param {string} option - The selected answer option
   * @returns {Promise<void>}
   * @description
   * This function processes user's answer selection by:
   * 1. Disabling further selections while processing
   * 2. Checking if the selected option matches the correct answer
   * 3. Preparing appropriate response data based on whether the answer is correct:
   *    - Correct answers show success message and proceed to next question
   *    - Incorrect answers apply XP penalty and allow another attempt
   * 4. Submitting the answer to the server via userAttempt API
   * 5. If successful, updating the UI with new XP and progress data
   * 6. Updating chart data and chat state with new XP information if applicable
   */
  const submitAnswer = async (answer) => {
    try {
      if (answer === null || answer === undefined || answer === "") {
        showToast("Please select an answer", "error");
        return;
      }
      setShowLoader(true);
      let data = {
        answer: answer,
        numberOfAttempts: attemptCount + 1,
        questionBlockId: questionBlockId,
        type: "self_journey",
      };

      const response = await userAttempt(aiChatId, chapterIndex, data);
      if (response?.status !== 200) {
        showToast(
          "Error in submitting answer. Please try again later.",
          "error"
        );
        return;
      }

      const userAttemptResponse = response?.data?.data;
      if (!userAttemptResponse) {
        showToast("No response from server", "error");
        return;
      }
      const attemptBlock = userAttemptResponse?.block;
      const updatedXP = userAttemptResponse?.xpUpdate;

      if (attemptBlock?.content?.isCorrect) {
        let _remainingXP = attemptBlock?.content?.xpEarned;

        setData((prev) => {
          const updatedData = { ...prev };
          const index = updatedData.labels.indexOf(
            updatedXP?.topic.replaceAll("_", " ")
          );
          if (index !== -1) {
            updatedData.datasets[0].data[index] = updatedXP?.totalXP;
          }
          return updatedData;
        });
        setChats((prev) => {
          const updatedChats = prev.map((chat) => {
            if (chat.topic === updatedXP?.topic.replaceAll("_", " ")) {
              return {
                ...chat,
                totalXP: updatedXP?.totalXP,
                level: updatedXP?.currentLevel,
                xpToReachNextLevel: updatedXP?.xpToReachNextLevel,
                xpInLevel: updatedXP?.xpInLevel,
              };
            }
            return chat;
          });
          return updatedChats;
        });
        setAttemptCount((prev) => prev + 1);
        setPrevUserAnswer(attemptBlock.content.answer);
        showToast(`Correct Answer +${_remainingXP} XP`, "success");
        setIsSolved(true);
        setIsSolved(true);
      } else {
        showToast(`Incorrect Answer -2 XP. Try again!`, "error");
        setRemainingXP((prev) => prev - 2);
        setPrevUserAnswer(attemptBlock.content.answer);
        setIsSolved(false);
        // setDisableOptions(false);
      }

      if (attemptBlock?.content?.explanation?.length > 0) {
        setMessages((prev) => [
          ...prev,
          {
            role: "model",
            content: attemptBlock.content.explanation,
            isAttemptResponse: true,
            isCorrect: attemptBlock?.content?.isCorrect,
            createdAt: attemptBlock.createdAt,
          },
        ]);
        setChatPanel(true);
      }
    } catch (error) {
      console.error("Error in (submitAnswer): ", error);
      showToast("An error occurred while submitting your answer.", "error");
    } finally {
      setShowLoader(false);
    }
  };

  const validateAIChatForm = () => {
    try {
      if (!selectedPDF) {
        showToast("Please select a topic", "error");
        return false;
      }
      if (!currentGrade) {
        showToast("Please select a grade", "error");
        return false;
      }
      if (!language) {
        showToast("Please select a language", "error");
        return false;
      }
      if (!board) {
        showToast("Please select a board", "error");
        return false;
      }
      if (!region) {
        showToast("Please select a region", "error");
        return false;
      }
      if (!questionType) {
        showToast("Please select a question type", "error");
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error in (validateAIChatForm): ", error);
      return false;
    }
  };

  /**
   * Creates a new AI chat session.
   *
   * This function performs the following steps:
   * 1. Shows a loader and validates the AI chat form
   * 2. Finds and validates selected grade, board, region, and language objects
   * 3. Constructs data object with configuration parameters
   * 4. Calls API to create AI chat session
   * 5. Updates state with the new chat information
   * 6. Updates chart data to include the new topic
   * 7. Navigates to the newly created chat session
   *
   * @async
   * @function createNewChat
   * @returns {Promise<void>} Nothing
   * @throws {Error} If API call fails or chat creation encounters an error
   */
  const createNewChat = async () => {
    try {
      setShowLoader(true);
      const isValid = await validateAIChatForm();

      if (!isValid) {
        setShowLoader(false);
        return;
      }

      // actual values
      const _grade = gradeList.find((g) => g.id === currentGrade);
      const _boardObj = boardList.find((b) => b.id.toString() === board);
      const _regionObj = regionList.find((r) => r.id.toString() === region);
      const _languageObj = languageList.find(
        (l) => l.id.toString() === language
      );
      const _questionTypeObj = questionTypes.find(
        (t) => t.id.toString() === questionType
      );
      if (
        !_grade ||
        !_boardObj ||
        !_regionObj ||
        !_languageObj ||
        !_questionTypeObj
      ) {
        showToast("Please select valid options for all fields", "error");
        return false;
      }

      const _data = {
        config: {
          grade: _grade.grade_name.toLowerCase(),
          board: _boardObj.name.toLowerCase(),
          region: _regionObj.name.toLowerCase(),
          language: _languageObj.name.toLowerCase(),
          questionType: _questionTypeObj.slug,
        },
        aiMode: "tutor",
        topic: "Self Journey",
        type: AIChatTypes.SELF_JOURNEY,
      };

      const formData = new FormData();
      formData.append("type", "self_journey");
      formData.append("file", selectedPDF);

      const uploadPdfResponse = await addPDF(formData)

      if (uploadPdfResponse?.status !== 200) {
        showToast("Error in uploading PDF", "error");
        return;
      }

      const pdfData = uploadPdfResponse?.data?.data;
      if (!pdfData) {
        showToast("PDF upload failed", "error");
        return;
      }
      _data.topic = pdfData.name
      _data.config = {
        ..._data.config,
        pdfId: pdfData.cardItemID,
        pdfName: pdfData.name,
        pdfViewKey: pdfData.key,
      }

      console.log("Creating new chat with data: ", _data);

      const response = await createAIChatSession(_data).catch((error) => {
        console.error("Error in creating new chat: ", error);
        showToast(
          error?.response?.data?.message || "Error in creating new chat",
          "error"
        );
        return;
      });
      if (response?.status !== 200) return;

      const newChat = response?.data?.data?.block;
      const newAIChatDetails = response?.data?.data?.block;
      if (!newChat) {
        showToast("Can't create new chat", "error");
        return;
      }
      console.log("New chat created: ", newChat);
      const _chapters = Object.keys(newChat.config?.chapterMeta)?.map((key) => {
        return {
          index: key,
          title: newChat.config.chapterMeta[key].title,
          id: key
        };
      })
      const sessionId = newChat?.id;
      const newTopic = newChat?.topic?.replaceAll("_", " ");
      setChats((prev) => [
        {
          ...newChat,
          chapters: _chapters,  
          topic: newTopic,
          totalXP: 0,
          level: 1,
          xpToReachNextLevel: 100,
          xpInLevel: 0,
          questionCount: 0,
        },
        ...prev,
      ]);

      setData((prev) => {
        const updatedData = { ...prev };
        if (updatedData?.labels?.length > 0) {
          updatedData.labels.push(newTopic);
          updatedData.datasets[0].data.push(0);
          return updatedData;
        } else {
          return {
            labels: [newTopic],
            datasets: [
              {
                label: "XP",
                data: [0],
                backgroundColor: "rgba(140, 199, 59, 0.2)",
                borderColor: "rgba(140, 199, 59, 1)",
                borderWidth: 1,
                pointBackgroundColor: "rgba(140, 199, 59, 1)",
                fill: false,
              },
            ],
          };
        }
      });

      if (window.innerWidth <= 800) {
        setSidePanel(false);
      }

      
      setAIChatDetails(newAIChatDetails);
      handleCloseConfigurationModal();
      navigate(`/ai-self-learning-journey/${sessionId}`);
    } catch (error) {
      console.error("Error in (createNewChat): ", error);
      showToast(`Error in creating new chat. ${error?.message || ""}`, "error");
    } finally {
      setShowLoader(false);
    }
  };

  // fetch user's grade
  const getGrade = async (_userProfileDetailsID) => {
    try {
      setShowLoader(true);
      let gradeDataQuery = await fetchItemsNextToken({
        query: listTblGradeMasters,
        variables: { filter: { status: { eq: 1 } } },
      });
      if (!gradeDataQuery) throw Error("Error in fetching grade master table");

      let getGradeData = gradeDataQuery?.filter(
        (item) => item._deleted !== true
      );
      if (!getGradeData.length)
        console.error("grade master table: ", getGradeData);

      setGradeList(getGradeData.sort((a, b) => a.series - b.series));
      let educationCard = await fetchSearchItemsNextToken({
        query: searchCards,
        variables: {
          filter: {
            userprofiledetailsID: { eq: _userProfileDetailsID },
            title: { eq: "education" },
          },
        },
      });
      if (!educationCard.length) return;

      let educationCardItems = await fetchSearchItemsNextToken({
        query: searchCardItems,
        variables: {
          filter: { cardID: { eq: educationCard[0].id }, status: { eq: 1 } },
          limit: 500,
        },
      });
      if (!educationCardItems.length) return;

      let sortedEducationCardItems = educationCardItems.sort((a, b) =>
        b.createdAt.localeCompare(a.createdAt)
      );
      let currentEducationCardItem = sortedEducationCardItems.filter(
        (item) => JSON.parse(item.newdata).currentlyStudying === true
      );

      let gradeData = null;
      let gradeListData = null;
      if (!currentEducationCardItem.length) {
        gradeData = JSON.parse(sortedEducationCardItems[0].newdata);
      } else {
        gradeData = JSON.parse(currentEducationCardItem[0].newdata);
      }
      gradeListData = getGradeData.filter(
        (item) => item.id == gradeData.endGrade
      );

      setCurrentGrade(gradeListData[0].id);
    } catch (error) {
      console.error("Error in (getGrade): ", error);
      showToast("Error in fetching grade", "error");
    } finally {
      setShowLoader(false);
    }
  };

  // Fetch chat data
  const getChatData = async (id, questionIndex = null, chapter = null) => {
    try {
      setShowLoader(true);
      console.log("Generating chat data for ID: ", id, " Question Index: ", questionIndex, " Chapter: ", chapter);
      if (!id) return;
      const response = await fetchAIChatBlocks(id, questionIndex, chapter);
      if (response?.status !== 200) throw Error("Error in fetching AI chat");

      const chatSession = response?.data?.data?.block;
      const aiChatDetails = response?.data?.data?.aiChatDetails;
      if (!chatSession) throw Error("No chat session found");

      setAIChatDetails(aiChatDetails);

      const questionBlock = chatSession.find(
        (block) => block.type === "generatedQuestion"
      );
      if (!questionBlock) {
        await fetchQuestion();
        return;
      }
      setQuestionData(questionBlock);

      //attempt details
      const attemptDetails = chatSession.filter(
        (block) => block.type === "userAttempt"
      );

      //helper content
      const helperContent = chatSession.filter(
        (block) =>
          block.type === "helperPrompt" || block.type === "helperResponse"
      );
      calculateCurrentAttemptProgress(attemptDetails, helperContent);
      setMessages((prev) =>
        [
          ...prev,
          ...helperContent.map((item) => ({
            role: item.actor === "user" ? "user" : "model",
            content: item.content.content,
            createdAt: item.createdAt,
          })),
        ].sort((a, b) => a.createdAt.localeCompare(b.createdAt))
      );
    } catch (error) {
      console.error("Error in (getChatData): ", error);
      showToast("Error in fetching chat data", "error");
    } finally {
      setShowLoader(false);
    }
  };

  const getNewData = async () => {
    let userDetailsID = localStorage.getItem("userDetailsID");
    await dispatch(getAllInterestsAction());
    await dispatch(getUserInterestsAction(userDetailsID));
    await dispatch(getUserSubInterestsAction(userDetailsID));
    setShowPopup(false);
  };

  const showToast = (message, severity = "info") => {
    setOpenToast(false);

    setTimeout(() => {
      setToastMsg(message);
      setSeverityClass(severity);
      setOpenToast(true);
    }, 100);
  };

  const moveQuestionIndex = async (direction) => {
    try {
      const newIndex = currentQuestionIndex + direction;
      await getChatData(aiChatId, newIndex);

      setCurrentQuestionIndex(newIndex);
    } catch (error) {
      console.error("Error in moveQuestionIndex:", error);
      showToast(
        "An error occurred while moving to the next question.",
        "error"
      );
      return;
    }
  };

  const handleReportTagsSelection = (tag) => {
    setSelectedTag((prev) => {
      if (prev.includes(tag)) {
        return prev.filter((t) => t !== tag);
      } else {
        return [...prev, tag];
      }
    });
  };

  const handleOpenReportModal = ({ reportFor, index = -1, blockId = null }) => {
    try {
      setOpenReportModal(true);
      setReportFor(reportFor);
      setReportBlockId(blockId);
    } catch (error) {
      console.error("Error in handleReport: ", error);
      showToast("Failed to open Reporting UI. Please try again later!", "error");
      setOpenToast(true);
    } finally {
      setShowLoader(false);
    }
  };

  const handleReport = async () => {
    try {
      setShowLoader(true);
      let reportTags = selectedTag.map((tag) => {
        let _tag = reportTagsList.find((t) => t.id === tag);
        return {
          id: _tag.id,
          name: _tag.name,
          slug: _tag.slug,
        };
      });

      let content = {};
      let history = messages;

      if (!reportTags?.length) {
        showToast("Please select at least one tag", "error");
        return;
      }

      if (reportFor === "QUESTION") {
        content = {
          type: aiChatDetails?.config?.questionType || null,
          data: {
            question: currentQuestion.question,
            options: currentQuestion.options,
            // correctAnswer: correctAnswer,
            // selectedOption: selectedOption,
            questionIndex: currentQuestionIndex,
          },
        };
      } else if (reportFor === "CHAT") {
        // _model = {
        //   ...chatModel || null
        // }
        // prompt = {
        //   userPrompt: messages
        //   .filter((message) => !message?.hidden)[reportIndex-1]?.content || null,
        //   content: messages
        //   .filter((message) => !message?.hidden)[reportIndex]?.content || null
        // }
        // content = {
        //   type: "CHAT",
        //   data: {
        //     messages: messages,
        //   },
        // }
      }

      let reportObj = {
        newData: {
          content: content,
          reportTags: reportTags,
          additionalInfo: reportText,
          aiChatId,
          aiChatBlockId: reportBlockId,
        },
        chatHistory: history || null,
      };
      const reportResponse = await reportAI(reportObj);
      if (!reportResponse.status === 200) throw new Error("Error in reporting");

      showToast("Reported successfully", "success");
      setReportText("");
      setSelectedTag([]);
      setOpenReportModal(false);
      setReportFor(null);
    } catch (error) {
      console.error("Error in handleReport: ", error);
      showToast("Failed to send report. Please try again later", "error");
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      console.log("[MAIN USEEFFECT]");
      if (aiChatId) {
        // await getChatData(aiChatId);
        if(chats.length > 0) {
          const currentChat = chats.find(chat => chat.id === aiChatId);
          console.log("[MAIN USEEFFECT] chapters: ", currentChat?.chapters);
          setSelectedChat(currentChat);
          setChapters(currentChat?.chapters || []);
        }
      }
      await getGrade(localStorage.getItem("userDetailsID"));
    };
    init();
  }, []);

  useEffect(() => {
    console.log("location changed: ", location.pathname, chats, chapters);
    if (aiChatId) {
      resetAll();
      if (chapterIndex !== null) {
        console.log("Chapter found in URL: ", chapterIndex);
        getChatData(aiChatId, null, chapterIndex ? parseInt(chapterIndex) : null);
      }
      if(aiChatId !== null && chats.length > 0) {
        const currentChat = chats.find(chat => chat.id === aiChatId);
        console.log("chapters: ", currentChat?.chapters);
        setSelectedChat(currentChat);
        setChapters(currentChat?.chapters || []);
        if (currentChat) {
          if (chats[0].id !== aiChatId) {
            const updatedChats = chats.filter(chat => chat.id !== aiChatId);
            setChats([currentChat, ...updatedChats]);
          }
          setLatestQuestionIndex(0);
        }
      }
    }
  }, [location.pathname, chapterIndex]);

  useEffect(() => { console.log(aiChatDetails) },[aiChatDetails])
  useEffect(() => {console.log(currentQuestion)},[currentQuestion])

  return (
    <div className={styles.ai_demo_wrapper}>
      <Header />
      {showLoader && <Loader visible={showLoader} />}
      {showPopup === true && (
        <InterestsPop
          openPopup={showPopup}
          showCancelBtn={true}
          onClosePopup={(data) => getNewData()}
        />
      )}

      <Snackbar
        open={openToast}
        autoHideDuration={3500}
        onClose={handleCloseToast}
      >
        <Alert
          variant="filled"
          onClose={handleCloseToast}
          severity={severityClass}
          sx={{ width: "100%" }}
        >
          {toastMsg}
        </Alert>
      </Snackbar>

      {/* Configuration Modal */}
      <CustomModal
        open={openConfigurationModal}
        handleClose={handleCloseConfigurationModal}
      >
        <h3 className={styles.config_modal_header}>
          Choose Skill{" "}
          <span className={styles.btn} onClick={() => setShowPopup(true)}>
            Add Skills
          </span>
        </h3>
        <div className={styles.config_modal_body}>
          <div className={styles.input_row}>
            <div className={styles.input_wrapper}>
              <label>Upload Your Content</label>
              <input
                type="file"
                className={styles.input_box}
                accept=".pdf"
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    setSelectedPDF(e.target.files[0]);
                  } else {
                    setSelectedPDF(null);
                  }
                }}
              />
            </div>
          </div>

          <div className={styles.input_row}>
            <div className={styles.input_wrapper}>
              <label>Grade</label>
              <select
                className={styles.input_box}
                // className="input_text select"
                value={currentGrade}
                onChange={(e) => setCurrentGrade(e.target.value)}
              >
                <option value={null} disabled>
                  Select Your Grade
                </option>
                {gradeList.map((grade) => {
                  return (
                    <option key={grade.id} value={grade.id}>
                      {grade.grade_name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className={styles.input_wrapper}>
              <label>Language</label>
              <select
                className={styles.input_box}
                // className="input_text select"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value={null} disabled>
                  Select your language
                </option>
                {languageList.map((lang) => {
                  return (
                    <option key={lang.id} value={lang.id}>
                      {lang.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className={styles.input_row}>
            <div className={styles.input_wrapper}>
              <label>Board</label>
              <select
                className={styles.input_box}
                value={board}
                onChange={(e) => setBoard(e.target.value)}
              >
                {/* <option value={null}>General</option> */}
                {boardList.map((board) => {
                  return (
                    <option key={board.id} value={board.id}>
                      {board.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className={styles.input_wrapper}>
              <label>Region</label>
              <select
                className={styles.input_box}
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              >
                <option value={null} disabled>
                  Select your region
                </option>
                {regionList.map((region) => {
                  return (
                    <option key={region.id} value={region.id}>
                      {region.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          <div className={styles.input_row}>
            <div className={styles.input_wrapper}>
              <label>Question Type</label>
              <select
                className={styles.input_box}
                value={questionType}
                onChange={(e) => setQuestionType(e.target.value)}
              >
                <option value={null} disabled>
                  Select your question type
                </option>
                {questionTypes.map((type) => {
                  return (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>

        <div className={styles.config_modal_footer}>
          <button
            className={`${styles.btn} ${styles.outline}`}
            onClick={() => handleCloseConfigurationModal()}
          >
            <span>Cancel</span>
            <CloseOutlined style={{ fontSize: "16px" }} />
          </button>
          <button
            className={styles.btn}
            onClick={() => {
              createNewChat();
            }}
          >
            <span>Start</span>
          </button>
        </div>
      </CustomModal>

      {/* Report Modal */}
      <CustomModal open={openReportModal} handleClose={handleCloseReportModal}>
        <h3 className={styles.config_modal_header}>Report</h3>
        <div className={styles.config_modal_body}>
          <div className={styles.input_wrapper}>
            <label>Select:</label>
            <div className={styles.tags_wrapper}>
              {reportTagsList.map((tag) => (
                <div
                  className={`${styles.tag} ${
                    selectedTag.includes(tag.id) ? styles.selected : ""
                  }`}
                  key={tag.id + tag.slug}
                  onClick={() => {
                    handleReportTagsSelection(tag.id);
                  }}
                >
                  {tag.name}
                </div>
              ))}
            </div>
          </div>
          <div className={styles.input_wrapper}>
            <label>Additional details (optional):</label>
            <textarea
              className={styles.input_text}
              placeholder="Type here..."
              value={reportText}
              onChange={(e) => setReportText(e.target.value)}
            ></textarea>
          </div>
        </div>

        {/* Action Buttons */}
        <div className={styles.config_modal_footer}>
          <button className={`${styles.btn}`} onClick={handleCloseReportModal}>
            <span style={{ fontSize: "14px" }}>Cancel</span>
            <CloseOutlined style={{ fontSize: "14px" }} />
          </button>
          <button
            className={styles.btn}
            style={{
              backgroundColor: "#E33232",
            }}
            onClick={async () => {
              await handleReport();
            }}
          >
            <span style={{ fontSize: "14px" }}>Report</span>
            <ErrorOutline style={{ fontSize: "14px" }} />
          </button>
        </div>
      </CustomModal>

      <Box className={styles.ai_body}>
        <SidePanel
          styles={styles}
          sidePanel={sidePanel}
          setSidePanel={setSidePanel}
          profile={profile}
          chats={chats}
          setChats={setChats}
          selectedChat={selectedChat}
          setSelectedChat={setSelectedChat}
          chapters={chapters}
          chapterIndex={chapterIndex}
          setChapters={setChapters}
          selectedChapter={selectedChapter}
          setSelectedChapter={setSelectedChapter}
          setOpenConfigurationModal={setOpenConfigurationModal}
          setLatestQuestionIndex={setLatestQuestionIndex}
          getChatData={getChatData}
          updateChartData={updateChartData}
          setData={setData}
          setShowLoader={setShowLoader}
          resetAll={resetAll}
          showToast={showToast}
        />

        <div className={styles.main_panel}>
          {aiChatDetails === null && (
            <div className={styles.info_message}>
              <p className={styles.header}>Let’s Level Up Your Learning</p>
              <div className={styles.text}>
                Welcome to your AI Tutor! 🚀 I'm here to help you level up your
                skills by asking questions and guiding you toward the right
                answers. I'll challenge you with questions—if you get it right,
                we move forward. If not, don't worry! I'll guide you step by
                step to help you understand and master the concept
              </div>
              <button
                className={styles.btn}
                onClick={() => setOpenConfigurationModal(true)}
              >
                Ready to learn? Let's Go
              </button>
            </div>
          )}

          {aiChatDetails && currentQuestion && (
            <>
              <QuestionRenderer
                styles={styles}
                showLoader={showLoader}
                sidePanel={sidePanel}
                aiChatDetails={aiChatDetails}
                questionContent={{
                  id: questionBlockId,
                  index: currentQuestionIndex,
                  ...currentQuestion,
                }}
                prevUserAnswer={prevUserAnswer}
                isSolved={isSolved}
                showToast={showToast}
                submitAnswer={submitAnswer}
                fetchQuestion={fetchQuestion}
                getChatData={getChatData}
                handleOpenReportModal={handleOpenReportModal}
                moveQuestionIndex={moveQuestionIndex}
                currentQuestionIndex={currentQuestionIndex}
                latestQuestionIndex={latestQuestionIndex}
                remainingXP={remainingXP}
              />

              <ChatPanel
                styles={styles}
                messages={messages}
                setMessages={setMessages}
                chatPanel={chatPanel}
                setChatPanel={setChatPanel}
                aiMode={aiMode}
                showToast={showToast}
                isSolved={isSolved}
                setRemainingXP={setRemainingXP}
                currentQuestionIndex={currentQuestionIndex}
              />
            </>
          )}
        </div>

        <ChartPanel
          styles={styles}
          data={data}
          chartPanel={chartPanel}
          setChartPanel={setChartPanel}
          isSolved={isSolved}
        />
      </Box>
    </div>
  );
};

export default AIOwnJourney;
